import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: {
          Login: "Login",
          "Your Loyalty": "Your Loyalty",
          "Our Gratitude!": "Our Gratitude!",
          "Join our exclusive loyalty program and start earning rewards today.":
            "Join our exclusive loyalty program and start earning rewards today.",
          "Join Now": "Join Now",
          "Getting Started is Easy!": "Getting Started is Easy!",
          "Join our family and start earning points":
            "Join our family and start earning points.",
          "Join Us": "Join Us",
          "Sign Up": "Sign Up",
          "Become a member by visiting any of our retail outlets or signing up online through our website.":
            "Become a member by visiting any of our retail outlets or signing up online through our website.",
          Registration: "Registration",
          "Simply provide your name, contact information, and create an account. It's quick and easy!":
            "Simply provide your name, contact information, and create an account. It's quick and easy!",
          "Welcome Bonus": "Welcome Bonus",
          "As a new member, receive 250 bonus points just for signing up.":
            "As a new member, receive 250 bonus points just for signing up.",
          "Earn Points": "Earn Points",
          "How It Works": "How It Works",
          "Earn 1 loyalty point for every Rs 200 spent in-store or online.":
            "Earn 1 loyalty point for every Rs 200 spent in-store or online.",
          "Bonus Points": "Bonus Points",
          "Enjoy special promotions where you can earn extra points on specific products or during special events.":
            "Enjoy special promotions where you can earn extra points on specific products or during special events.",
          "Track Your Points": "Track Your Points",
          "Easily track your points and rewards through our mobile app or website.":
            "Easily track your points and rewards through our mobile app or website.",
          "Redeem Points": "Redeem Points",
          "Use Your Points": "Use Your Points",
          "Minimum number of points required to be able to redeem is 500 points, redeem them for exciting rewards such as discounts, free products, or exclusive experiences.":
            "Minimum number of points required to be able to redeem is 500 points, redeem them for exciting rewards such as discounts, free products, or exclusive experiences.",
          "Redemption Process": "Redemption Process",
          "Simply select your reward during checkout, either in-store or online, and apply your points toward the total purchase amount.":
            "Simply select your reward during checkout, either in-store or online, and apply your points toward the total purchase amount.",
          "Points Expiry": "Points Expiry",
          "Don't forget to use your points before they expire! Points are valid for 12 months from the date they're earned.":
            "Don't forget to use your points before they expire! Points are valid for 12 months from the date they're earned.",
        },
      },
      si: {
        translation: {
          Login: "පිවිසෙන්න",
          "Your Loyalty": "ඔබගේ විශ්වාසය",
          "Our Gratitude!": "අපගේ කෘතඥතාව!",
          "Join our exclusive loyalty program and start earning rewards today.":
            "අපගේ ලෝයල්ටි වැඩසටහනට එක්වී අදම ප්‍රතිලාභ ලබා ගැනීමට ආරම්භ කරන්න.",
          "Join Now": "දැන්ම එකතු වන්න",
          "Getting Started is Easy!": "ආරම්භ කිරීම පහසුය!",
          "Join our family and start earning points":
            "අප හා එක් වී ලකුණු උපයා ගැනීම ආරම්භ කරන්න.",
          "Join Us": "අප හා එක් වන්න",
          "Sign Up": "ලියාපදිංචි වන්න",
          "Become a member by visiting any of our retail outlets or signing up online through our website.":
            "අපගේ ඕනෑම වෙළඳසැලකින් හෝ අපගේ වෙබ් අඩවිය හරහා මාර්ගගතව ලියාපදිංචි වීමෙන් සාමාජිකයෙකු වන්න.",
          Registration: "ලියාපදිංචි වන්න",
          "Simply provide your name, contact information, and create an account. It's quick and easy!":
            "ඔබගේ නම සහ සම්බන්ධතා තොරතුරු ලබා දීමෙන් ගිණුමක් සාදන්න. එය ඉක්මන් හා පහසුයි!",
          "Welcome Bonus": "ලියාපදිංචි දීමනා",
          "As a new member, receive 250 bonus points just for signing up.":
            "ලියාපදිංචි වන විට ප්‍රසාද ලකුණු 250ක් ලබා ගන්න.",
          "Earn Points": "ලකුණු උපයන්න",
          "How It Works": "ක්‍රියා කරනා ආකරය",
          "Earn 1 loyalty point for every Rs 200 spent in-store or online.":
            "වෙළඳසැල තුළ හෝ අන්තර්ජාලය හරහා වියදම් කරන සෑම රුපියල් 200 කටම ලකුණු 1ක් උපයන්න.",
          "Bonus Points": "ප්‍රසාද ලකුණු",
          "Enjoy special promotions where you can earn extra points on specific products or during special events.":
            "විශේෂ නිෂ්පාදන සඳහා හෝ විශේෂ සිදුවීම් අතරතුර අමතර ලකුණු උපයා ගත හැකි විශේෂ ප්‍රවර්ධන භුක්ති විඳින්න.",
          "Track Your Points": "ඔබේ ලකුණු නිරීක්ෂණය කරන්න",
          "Easily track your points and rewards through our mobile app or website.":
            "අපගේ  වෙබ් අඩවිය හරහා ඔබේ ලකුණු සහ ත්‍යාග පහසුවෙන් නිරීක්ෂණය කරන්න.",
          "Redeem Points": "ලකුණු මුදා ගන්න",
          "Use Your Points": "ලකුණු භාවිතා කරන්න",
          "Minimum number of points required to be able to redeem is 500 points, redeem them for exciting rewards such as discounts, free products, or exclusive experiences.":
            "මුදවා ගැනීමට අවශ්‍ය අවම ලකුණු සංඛ්‍යාව 500 කි. එම ලකුණු මඟින් වට්ටම්, නොමිලේ නිෂ්පාදන හෝ සුවිශේෂී අත්දැකීම් වැනි ආකර්ෂණීය ත්‍යාග සඳහා ඒවා මුදවා ගන්න.",
          "Redemption Process": "මුදාගැනීමේ ක්‍රියාවලිය",
          "Simply select your reward during checkout, either in-store or online, and apply your points toward the total purchase amount.":
            "වෙළඳසැල තුළ හෝ ඔන්ලයින් මිලදී ගැනීමකදී ඔබේ ත්‍යාගය තෝරාගෙන මුළු මිලදී ගැනීමේ මුදලට ඔබේ ලකුණු යොදන්න.",
          "Points Expiry": "ලකුණු කල් ඉකුත් වීම",
          "Don't forget to use your points before they expire! Points are valid for 12 months from the date they're earned.":
            "ඔබේ ලකුණු කල් ඉකුත් වීමට පෙර භාවිතා කිරීමට අමතක නොකරන්න! ලකුණු උපයාගත් දින සිට මාස 12ක් සඳහා වලංගු වේ.",
        },
      },
    },
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
